export interface Chapter {
  id: string;
  name: string;
  totalQuestions: number;
  tab?: 'ব্যাকরণ' | 'নির্মিতি';
  is_paid?: boolean;
  is_locked?: boolean;
}

export interface Subject {
  id: string;
  name: string;
  icon: string;
  chapters: Chapter[];
}

export const compulsorySubjects: Subject[] = [
  {
    id: 'sub_bn1',
    name: 'বাংলা ১ম পত্র',
    icon: 'BookOpen',
    chapters: [
      { id: 'b1_ch1', name: 'গদ্য: শুভা', totalQuestions: 120 },
      { id: 'b1_ch2', name: 'গদ্য: প্রত্যুপকার', totalQuestions: 95 },
      { id: 'b1_ch3', name: 'গদ্য: বইপড়া', totalQuestions: 110 },
      { id: 'b1_ch4', name: 'পদ্য: বঙ্গবাণী', totalQuestions: 85 },
      { id: 'b1_ch5', name: 'কবিতা: কপোতাক্ষ নদ', totalQuestions: 90 },
      { id: 'b1_ch6', name: 'কবিতা: আমি কিংবদন্তির কথা বলছি', totalQuestions: 100 },
      { id: 'b1_ch7', name: 'সহপাঠ: নাটক', totalQuestions: 75 },
      { id: 'b1_ch8', name: 'সহপাঠ: উপন্যাস', totalQuestions: 80 },
    ],
  },
  {
    id: 'sub_bn2',
    name: 'বাংলা ২য় পত্র',
    icon: 'BookOpen',
    chapters: [
      { id: 'b2_ch1', name: 'ধ্বনিতত্ত্ব', totalQuestions: 150, tab: 'ব্যাকরণ' },
      { id: 'b2_ch2', name: 'সন্ধি', totalQuestions: 120, tab: 'ব্যাকরণ' },
      { id: 'b2_ch3', name: 'নত্ব/ষত্ব বিধান', totalQuestions: 200, tab: 'ব্যাকরণ' },
      { id: 'b2_ch4', name: 'শব্দ ও পদ', totalQuestions: 180, tab: 'ব্যাকরণ' },
      { id: 'b2_ch5', name: 'সমাস', totalQuestions: 220, tab: 'ব্যাকরণ' },
      { id: 'b2_ch6', name: 'উপসর্গ', totalQuestions: 100, tab: 'ব্যাকরণ' },
      { id: 'b2_ch7', name: 'প্রত্যয়', totalQuestions: 130, tab: 'ব্যাকরণ' },
      { id: 'b2_ch8', name: 'বিভক্তি ও কারক', totalQuestions: 160, tab: 'ব্যাকরণ' },
      { id: 'b2_ch9', name: 'বাক্য প্রকরণ', totalQuestions: 140, tab: 'ব্যাকরণ' },
      { id: 'b2_ch10', name: 'নির্মিতি অংশ', totalQuestions: 110, tab: 'নির্মিতি' },
    ],
  },
  {
    id: 'sub_eng1',
    name: 'ইংরেজি ১ম পত্র',
    icon: 'Languages',
    chapters: [
      { id: 'e1_ch1', name: 'Unit 1: Good Citizens', totalQuestions: 100 },
      { id: 'e1_ch2', name: 'Unit 2: Pastimes', totalQuestions: 95 },
      { id: 'e1_ch3', name: 'Unit 3: Adolescence', totalQuestions: 110 },
      { id: 'e1_ch4', name: 'Unit 4: Environment and Nature', totalQuestions: 105 },
      { id: 'e1_ch5', name: 'Unit 5: Peace and Conflict', totalQuestions: 90 },
      { id: 'e1_ch6', name: 'Unit 6: Tourism', totalQuestions: 85 },
    ],
  },
  {
    id: 'sub_eng2',
    name: 'ইংরেজি ২য় পত্র',
    icon: 'Languages',
    chapters: [
      { id: 'e2_ch1', name: 'Tense', totalQuestions: 200 },
      { id: 'e2_ch2', name: 'Right Form of Verbs', totalQuestions: 180 },
      { id: 'e2_ch3', name: 'Preposition', totalQuestions: 150 },
      { id: 'e2_ch4', name: 'Articles', totalQuestions: 120 },
      { id: 'e2_ch5', name: 'Narration', totalQuestions: 140 },
      { id: 'e2_ch6', name: 'Voice Change', totalQuestions: 130 },
      { id: 'e2_ch7', name: 'Punctuation', totalQuestions: 100 },
      { id: 'e2_ch8', name: 'Completing Sentences', totalQuestions: 160 },
    ],
  },
  {
    id: 'sub_math',
    name: 'গণিত',
    icon: 'Calculator',
    chapters: [
      { id: 'm_ch1', name: 'Chapter 1: Real Numbers', totalQuestions: 150 },
      { id: 'm_ch2', name: 'Chapter 2: Sets and Functions', totalQuestions: 140 },
      { id: 'm_ch3', name: 'বীজগাণিতিক রাশি', totalQuestions: 160 },
      { id: 'm_ch4', name: 'সূচক ও লগারিদম', totalQuestions: 130 },
      { id: 'm_ch5', name: 'এক চলকবিশিষ্ট সমীকরণ', totalQuestions: 170 },
      { id: 'm_ch6', name: 'রেখা, কোণ ও ত্রিভুজ', totalQuestions: 145 },
      { id: 'm_ch7', name: 'ব্যবহারিক জ্যামিতি', totalQuestions: 120 },
      { id: 'm_ch8', name: 'বৃত্ত', totalQuestions: 155 },
      { id: 'm_ch9', name: 'ত্রিকোণমিতিক অনুপাত', totalQuestions: 135 },
      { id: 'm_ch10', name: 'দূরত্ব ও উচ্চতা', totalQuestions: 110 },
      { id: 'm_ch11', name: 'বীজগাণিতিক অনুপাত ও সমানুপাত', totalQuestions: 125 },
      { id: 'm_ch12', name: 'দুই চলকবিশিষ্ট সমীকরণ', totalQuestions: 140 },
      { id: 'm_ch13', name: 'সরল ও যৌগিক সুদ', totalQuestions: 115 },
      { id: 'm_ch14', name: 'বীজগাণিতিক সূত্রাবলি প্রয়োগ', totalQuestions: 130 },
      { id: 'm_ch15', name: 'ক্ষেত্রফল সম্পর্কিত উপপাদ্য ও সম্পাদ্য', totalQuestions: 100 },
      { id: 'm_ch16', name: 'পরিমিতি', totalQuestions: 120 },
      { id: 'm_ch17', name: 'পরিসংখ্যান', totalQuestions: 110 },
    ],
  },
  {
    id: 'sub_ict',
    name: 'তথ্য ও যোগাযোগ প্রযুক্তি',
    icon: 'Monitor',
    chapters: [
      { id: 'ict_ch1', name: 'তথ্য ও যোগাযোগ প্রযুক্তি: বিশ্ব ও বাংলাদেশ প্রেক্ষিত', totalQuestions: 130 },
      { id: 'ict_ch2', name: 'কমিউনিকেশন সিস্টেম ও নেটওয়ার্কিং', totalQuestions: 150 },
      { id: 'ict_ch3', name: 'সংখ্যা পদ্ধতি ও ডিজিটাল ডিভাইস', totalQuestions: 140 },
      { id: 'ict_ch4', name: 'ওয়েব ডিজাইন পরিচিতি ও HTML', totalQuestions: 160 },
      { id: 'ict_ch5', name: 'প্রোগ্রামিং ভাষা', totalQuestions: 170 },
      { id: 'ict_ch6', name: 'ডেটাবেজ-এর ব্যবহার', totalQuestions: 145 },
    ],
  },
  {
    id: 'sub_religion',
    name: 'ধর্ম ও নৈতিক শিক্ষা',
    icon: 'Heart',
    chapters: [
      { id: 'rel_ch1', name: 'আকাইদ', totalQuestions: 100 },
      { id: 'rel_ch2', name: 'নৈতিক শিক্ষা', totalQuestions: 120 },
      { id: 'rel_ch3', name: 'ফিকহ', totalQuestions: 90 },
      { id: 'rel_ch4', name: 'ইসলামের ইতিহাস', totalQuestions: 110 },
    ],
  },
];

export const scienceSubjects: Subject[] = [
  {
    id: 'sub_phy',
    name: 'পদার্থবিজ্ঞান',
    icon: 'Atom',
    chapters: [
      { id: 'phy_ch1', name: 'Chapter 1: Physical Quantities', totalQuestions: 140 },
      { id: 'phy_ch2', name: 'Chapter 2: Motion', totalQuestions: 160 },
      { id: 'phy_ch3', name: 'বল', totalQuestions: 150 },
      { id: 'phy_ch4', name: 'কাজ, শক্তি ও ক্ষমতা', totalQuestions: 130 },
      { id: 'phy_ch5', name: 'চাপ ও পৃথিবীর মাধ্যাকর্ষণ', totalQuestions: 145 },
      { id: 'phy_ch6', name: 'পদার্থের অবস্থা ও চাপ', totalQuestions: 120 },
      { id: 'phy_ch7', name: 'তাপগতিবিদ্যা', totalQuestions: 135 },
      { id: 'phy_ch8', name: 'আলোর প্রতিফলন', totalQuestions: 110 },
      { id: 'phy_ch9', name: 'আলোর প্রতিসরণ', totalQuestions: 125 },
      { id: 'phy_ch10', name: 'স্থির তড়িৎ', totalQuestions: 155 },
      { id: 'phy_ch11', name: 'চল তড়িৎ', totalQuestions: 165 },
      { id: 'phy_ch12', name: 'চৌম্বকত্ব ও চৌম্বক ক্রিয়া', totalQuestions: 130 },
      { id: 'phy_ch13', name: 'আধুনিক পদার্থবিজ্ঞান', totalQuestions: 100 },
    ],
  },
  {
    id: 'sub_chem',
    name: 'রসায়ন',
    icon: 'FlaskConical',
    chapters: [
      { id: 'chem_ch1', name: 'Chapter 1: Concepts of Chemistry', totalQuestions: 120 },
      { id: 'chem_ch2', name: 'Chapter 2: States of Matter', totalQuestions: 140 },
      { id: 'chem_ch3', name: 'রসায়নের গাণিতিক যোগাযোগ', totalQuestions: 130 },
      { id: 'chem_ch4', name: 'পর্যায় সারণি', totalQuestions: 150 },
      { id: 'chem_ch5', name: 'রাসায়নিক বন্ধন', totalQuestions: 160 },
      { id: 'chem_ch6', name: 'গ্যাসের ধর্ম', totalQuestions: 110 },
      { id: 'chem_ch7', name: 'তাপগতিবিদ্যা', totalQuestions: 125 },
      { id: 'chem_ch8', name: 'দ্রাব্যতা', totalQuestions: 115 },
      { id: 'chem_ch9', name: 'দ্রবণের ঘনমাত্রা', totalQuestions: 135 },
      { id: 'chem_ch10', name: 'তড়িৎ রসায়ন', totalQuestions: 145 },
      { id: 'chem_ch11', name: 'রাসায়নিক বিক্রিয়ার হার', totalQuestions: 130 },
      { id: 'chem_ch12', name: 'অজৈব রসায়ন', totalQuestions: 155 },
      { id: 'chem_ch13', name: 'জৈব রসায়ন', totalQuestions: 140 },
    ],
  },
  {
    id: 'sub_bio',
    name: 'জীববিজ্ঞান',
    icon: 'Dna',
    chapters: [
      { id: 'bio_ch1', name: 'কোষ ও এর গঠন', totalQuestions: 150 },
      { id: 'bio_ch2', name: 'কোষ বিভাজন', totalQuestions: 130 },
      { id: 'bio_ch3', name: 'কোষ রসায়ন', totalQuestions: 140 },
      { id: 'bio_ch4', name: 'জীবনীশক্তি', totalQuestions: 120 },
      { id: 'bio_ch5', name: 'খাদ্য ও পুষ্টি', totalQuestions: 110 },
      { id: 'bio_ch6', name: 'পরিবহন', totalQuestions: 135 },
      { id: 'bio_ch7', name: 'শ্বসন', totalQuestions: 125 },
      { id: 'bio_ch8', name: 'বর্জ্য ও নিষ্কাশন', totalQuestions: 100 },
      { id: 'bio_ch9', name: 'সমন্বয় ও নিয়ন্ত্রণ', totalQuestions: 145 },
      { id: 'bio_ch10', name: 'জনন', totalQuestions: 130 },
      { id: 'bio_ch11', name: 'জীবের বংশগতি ও বিবর্তন', totalQuestions: 155 },
      { id: 'bio_ch12', name: 'জীবের পরিবেশ, বিস্তার ও সংরক্ষণ', totalQuestions: 140 },
      { id: 'bio_ch13', name: 'জীবপ্রযুক্তি', totalQuestions: 115 },
    ],
  },
  {
    id: 'sub_hmath',
    name: 'উচ্চতর গণিত',
    icon: 'Sigma',
    chapters: [
      { id: 'hm_ch1', name: 'Chapter 1: Sets and Functions', totalQuestions: 160 },
      { id: 'hm_ch2', name: 'Chapter 2: Algebraic Relation', totalQuestions: 150 },
      { id: 'hm_ch3', name: 'সরলরেখা', totalQuestions: 140 },
      { id: 'hm_ch4', name: 'বৃত্ত', totalQuestions: 135 },
      { id: 'hm_ch5', name: 'বিন্যাস ও সমাবেশ', totalQuestions: 145 },
      { id: 'hm_ch6', name: 'ত্রিকোণমিতিক অনুপাত', totalQuestions: 130 },
      { id: 'hm_ch7', name: 'ত্রিকোণমিতিক অনুপাতের যোগফল ও বিয়োগফল', totalQuestions: 125 },
      { id: 'hm_ch8', name: 'ফাংশন ও ফাংশনের লেখচিত্র', totalQuestions: 155 },
      { id: 'hm_ch9', name: 'অন্তরীকরণ', totalQuestions: 165 },
      { id: 'hm_ch10', name: 'সমাকলন', totalQuestions: 170 },
    ],
  },
];

export const humanitiesSubjects: Subject[] = [
  {
    id: 'sub_hist',
    name: 'বাংলাদেশের ইতিহাস ও বিশ্বসভ্যতা',
    icon: 'Landmark',
    chapters: [
      { id: 'hist_ch1', name: 'ভারতবর্ষের প্রাচীন সভ্যতা', totalQuestions: 130 },
      { id: 'hist_ch2', name: 'বাংলাদেশের স্বাধীনতা যুদ্ধ', totalQuestions: 140 },
      { id: 'hist_ch3', name: 'ভারতবর্ষের মধ্যযুগ', totalQuestions: 150 },
      { id: 'hist_ch4', name: 'বিশ্বসভ্যতার ধারা', totalQuestions: 120 },
      { id: 'hist_ch5', name: 'ঔপনিবেশিক শাসন ও বাংলাদেশ', totalQuestions: 160 },
      { id: 'hist_ch6', name: 'বাংলার ইতিহাস', totalQuestions: 145 },
    ],
  },
  {
    id: 'sub_eco',
    name: 'অর্থনীতি',
    icon: 'TrendingUp',
    chapters: [
      { id: 'eco_ch1', name: 'অর্থনীতির মৌলিক ধারণা', totalQuestions: 120 },
      { id: 'eco_ch2', name: 'অর্থ ও ব্যাংকিং', totalQuestions: 140 },
    ],
  },
  {
    id: 'sub_geo',
    name: 'ভূগোল ও পরিবেশ',
    icon: 'Globe',
    chapters: [
      { id: 'geo_ch1', name: 'ভূগোলের মৌলিক ধারণা', totalQuestions: 130 },
      { id: 'geo_ch2', name: 'বাংলাদেশের ভূপ্রকৃতি', totalQuestions: 140 },
      { id: 'geo_ch3', name: 'জলবায়ু ও প্রাকৃতিক সম্পদ', totalQuestions: 150 },
      { id: 'geo_ch4', name: 'কৃষি ও শিল্প', totalQuestions: 120 },
      { id: 'geo_ch5', name: 'জনসংখ্যা ও নগরায়ণ', totalQuestions: 135 },
      { id: 'geo_ch6', name: 'পরিবেশ ও দুর্যোগ ব্যবস্থাপনা', totalQuestions: 145 },
    ],
  },
  {
    id: 'sub_civ',
    name: 'পৌরনীতি ও নাগরিকতা',
    icon: 'Scale',
    chapters: [
      { id: 'civ_ch1', name: 'পৌরনীতির ধারণা', totalQuestions: 120 },
      { id: 'civ_ch2', name: 'নাগরিক ও নাগরিকতা', totalQuestions: 140 },
      { id: 'civ_ch3', name: 'রাষ্ট্র ও সরকার', totalQuestions: 150 },
      { id: 'civ_ch4', name: 'গণতন্ত্র ও নির্বাচন', totalQuestions: 130 },
      { id: 'civ_ch5', name: 'বাংলাদেশের সংবিধান', totalQuestions: 160 },
      { id: 'civ_ch6', name: 'আন্তর্জাতিক সম্পর্ক', totalQuestions: 110 },
    ],
  },
  {
    id: 'sub_gsci',
    name: 'সাধারণ বিজ্ঞান',
    icon: 'Microscope',
    chapters: [
      { id: 'gs_ch1', name: 'জীবনীশক্তি', totalQuestions: 130 },
      { id: 'gs_ch2', name: 'পরিবেশ দূষণ', totalQuestions: 140 },
      { id: 'gs_ch3', name: 'পুষ্টি ও স্বাস্থ্য', totalQuestions: 120 },
      { id: 'gs_ch4', name: 'জৈবপ্রযুক্তি', totalQuestions: 110 },
      { id: 'gs_ch5', name: 'তথ্য ও যোগাযোগ প্রযুক্তি', totalQuestions: 150 },
    ],
  },
];

export const commerceSubjects: Subject[] = [
  {
    id: 'sub_acc',
    name: 'হিসাববিজ্ঞান',
    icon: 'FileText',
    chapters: [
      { id: 'acc_ch1', name: 'হিসাববিজ্ঞানের মৌলিক ধারণা', totalQuestions: 140 },
      { id: 'acc_ch2', name: 'লেনদেনের বিশ্লেষণ', totalQuestions: 150 },
      { id: 'acc_ch3', name: 'দ্বৈতনীতি', totalQuestions: 160 },
      { id: 'acc_ch4', name: 'নগদান বই', totalQuestions: 130 },
      { id: 'acc_ch5', name: 'ব্যাংক সমন্বয় বিবরণ', totalQuestions: 145 },
      { id: 'acc_ch6', name: 'পাওনাদার ও প্রদেয় হিসাব', totalQuestions: 120 },
      { id: 'acc_ch7', name: 'সমাপনি হিসাব', totalQuestions: 155 },
    ],
  },
  {
    id: 'sub_fin',
    name: 'ফিন্যান্স ও ব্যাংকিং',
    icon: 'Banknote',
    chapters: [
      { id: 'fin_ch1', name: 'হিসাববিজ্ঞানের মৌলিক ধারণা', totalQuestions: 130 },
      { id: 'fin_ch2', name: 'ব্যাংক ও ব্যাংকিং', totalQuestions: 150 },
      { id: 'fin_ch3', name: 'বীমা', totalQuestions: 140 },
      { id: 'fin_ch4', name: 'শেয়ারবাজার', totalQuestions: 120 },
      { id: 'fin_ch5', name: 'বাংলাদেশের অর্থনীতি', totalQuestions: 160 },
    ],
  },
  {
    id: 'sub_bus',
    name: 'ব্যবসায় উদ্যোগ',
    icon: 'Briefcase',
    chapters: [
      { id: 'bus_ch1', name: 'ব্যবসায় উদ্যোগের ধারণা', totalQuestions: 140 },
      { id: 'bus_ch2', name: 'উদ্যোক্তা', totalQuestions: 130 },
      { id: 'bus_ch3', name: 'ব্যবসায় পরিকল্পনা', totalQuestions: 150 },
      { id: 'bus_ch4', name: 'বাজারজাতকরণ', totalQuestions: 160 },
      { id: 'bus_ch5', name: 'ব্যবসায়িক যোগাযোগ', totalQuestions: 120 },
    ],
  },
  {
    id: 'sub_gsci',
    name: 'সাধারণ বিজ্ঞান',
    icon: 'Microscope',
    chapters: [
      { id: 'gsc_ch1', name: 'জীবনীশক্তি', totalQuestions: 130 },
      { id: 'gsc_ch2', name: 'পরিবেশ দূষণ', totalQuestions: 140 },
      { id: 'gsc_ch3', name: 'পুষ্টি ও স্বাস্থ্য', totalQuestions: 120 },
      { id: 'gsc_ch4', name: 'জৈবপ্রযুক্তি', totalQuestions: 110 },
      { id: 'gsc_ch5', name: 'তথ্য ও যোগাযোগ প্রযুক্তি', totalQuestions: 150 },
    ],
  },
];

export const optionalSubjects: Record<string, Subject> = {
  'কৃষি শিক্ষা': {
    id: 'opt_agri',
    name: 'কৃষি শিক্ষা',
    icon: 'Sprout',
    chapters: [
      { id: 'agr_ch1', name: 'কৃষির ধারণা ও গুরুত্ব', totalQuestions: 120 },
      { id: 'agr_ch2', name: 'মাটি ও এর ব্যবস্থাপনা', totalQuestions: 140 },
      { id: 'agr_ch3', name: 'সেচ ও পানি ব্যবস্থাপনা', totalQuestions: 130 },
      { id: 'agr_ch4', name: 'বীজ ও বপন', totalQuestions: 110 },
      { id: 'agr_ch5', name: 'ফসলের রোগবালাই ও পোকামাকড়', totalQuestions: 150 },
      { id: 'agr_ch6', name: 'পশুপালন', totalQuestions: 125 },
      { id: 'agr_ch7', name: 'মৎস্য চাষ', totalQuestions: 100 },
    ],
  },
  'গার্হস্থ্য বিজ্ঞান': {
    id: 'opt_home',
    name: 'গার্হস্থ্য বিজ্ঞান',
    icon: 'Home',
    chapters: [
      { id: 'hs_ch1', name: 'গার্হস্থ্য বিজ্ঞানের ধারণা', totalQuestions: 110 },
      { id: 'hs_ch2', name: 'পুষ্টি ও খাদ্য', totalQuestions: 140 },
      { id: 'hs_ch3', name: 'বস্ত্র ও পোশাক', totalQuestions: 130 },
      { id: 'hs_ch4', name: 'গৃহ ব্যবস্থাপনা', totalQuestions: 120 },
      { id: 'hs_ch5', name: 'শিশু যত্ন', totalQuestions: 100 },
      { id: 'hs_ch6', name: 'স্বাস্থ্য ও পরিচ্ছন্নতা', totalQuestions: 115 },
    ],
  },
};

export const boards = [
  'ঢাকা',
  'রাজশাহী',
  'চট্টগ্রাম',
  'খুলনা',
  'বরিশাল',
  'সিলেট',
  'দিনাজপুর',
  'ময়মনসিংহ',
  'কুমিল্লা',
  'যশোর',
  'মাদ্রাসা',
];

export const years = ['2026', '2025', '2024', '2023', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015'];

const optionalSubjectMapping: Record<string, string> = {
  'agriculture': 'কৃষি শিক্ষা',
  'home-science': 'গার্হস্থ্য বিজ্ঞান',
  'opt_agri': 'কৃষি শিক্ষা',
  'opt_home': 'গার্হস্থ্য বিজ্ঞান',
  'কৃষি শিক্ষা': 'কৃষি শিক্ষা',
  'গার্হস্থ্য বিজ্ঞান': 'গার্হস্থ্য বিজ্ঞান'
};

export function getSubjectsForUser(group: string, optional: string | null): Subject[] {
  let groupSubjects: Subject[] = [];
  if (group === 'science') groupSubjects = scienceSubjects;
  else if (group === 'humanities') groupSubjects = humanitiesSubjects;
  else if (group === 'commerce') groupSubjects = commerceSubjects;

  const mappedOptionalKey = optional ? optionalSubjectMapping[optional] || optional : null;
  const optionalSub = mappedOptionalKey && optionalSubjects[mappedOptionalKey] ? [optionalSubjects[mappedOptionalKey]] : [];
  return [...compulsorySubjects, ...groupSubjects, ...optionalSub];
}
